// extracted by mini-css-extract-plugin
export default {"tooltip":"GridButton_tooltip__OYK4-"};